<template>
  <div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">筛选查询</div>
      </div>
      <!-- 搜索筛选 -->
      <div>
        <div class="table_item_box">
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">批次号</div>

              <input
                v-model="screen.batchname"
                type="text"
                placeholder="请输入批次号"
                class="table_item_input"
              />
            </div>
          </div>
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">运单号</div>

              <input
                v-model="screen.ordernumber"
                type="text"
                placeholder="请输入运单号"
                class="table_item_input"
              />
            </div>
          </div>
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">国内单号</div>

              <input
                v-model="screen.domesticnumber"
                type="text"
                placeholder="请输入国内单号"
                class="table_item_input"
              />
            </div>
          </div>

          <div class="table_item_box_s" style="flex-direction: column-reverse">
            <div class="table_item_box_l_r"></div>
            <div class="table_item_box_l_s">
              <el-button type="primary" class="round_btn" @click="search" round
                >搜索</el-button
              >
              <el-button round @click="reset">重置</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">我要派送订单列表</div>
      </div>
      <div class="table_box">
        <el-table
         v-loading='tableLoading'
          :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
          ref="multipleTable"
          :data="orderData.content"
          tooltip-effect="dark"
          style="width: 100%"
          :row-key="getRowKeys"
          @selection-change="handleSelectionChange"
        >
          >
          <el-table-column
            :reserve-selection="true"
            label-class-name="DisabledSelection"
            width="100px"
            type="selection"
          >
          </el-table-column>
          <el-table-column align="center" prop="picktype" label="提货类型">
            <template slot-scope="scope">
              <div v-if="scope.row.picktype == 0">货运提货</div>
              <div v-if="scope.row.picktype == 1">商城团购提货</div>
              <div v-if="scope.row.picktype == 2">团购线到货</div>
                <div v-if="scope.row.picktype == null">-</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="loadDeliveryBatchName" label="批次号">
          </el-table-column>
          <el-table-column align="center" prop="ordernumber" label="运单号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="domesticnumber"
            label="国内运单号"
          >
          </el-table-column>
          <el-table-column align="center" prop="recipientname" label="收件人">
          </el-table-column>
          <el-table-column align="center" prop="weightkg" label="收费重量">
          </el-table-column>
          <el-table-column align="center" prop="baggagenum" label="总箱数">
          </el-table-column>
          <el-table-column align="center" prop="storagecost" label="仓储费用">
          </el-table-column>
          <el-table-column align="center" prop="shippingcost" label="总运费">
          </el-table-column>
        </el-table>
        <div class="paging_boxs" v-if="orderData.totalElements > 0">
          <div class="paging_box_io">
            <div>共{{ orderData.totalElements }}单，</div>
            <div style="color: #5178ffff">
              已选择{{ orderIds.length }}单
            </div>
          </div>
          <el-pagination
            @current-change="pageChange"
            background
            layout="prev, pager, next"
            :total="orderData.totalElements"
          >
          </el-pagination>
        </div>
      </div>
      <div class="step_box_s" @click="clickDelivery">
        <div class="last_step_l margin_right">要求送货</div>
      </div>
    </div>
    <el-dialog
      :center="true"
      title="第一步：确认送货信息"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <div class="fill_in_list">
        <div class="fill_in_list_l">
          <div class="fill_in_title">送货地址</div>
        </div>
        <div class="input_select">
          {{ selectAddress.province }}{{ selectAddress.city
          }}{{ selectAddress.district }}{{ selectAddress.detailArea }}
          {{ selectAddress.consignee }} {{ selectAddress.mobile }}
        </div>
      </div>
      <el-button type="text" class="text_btn" @click="selectAddressBtn"
        >选择其他地址></el-button
      >
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button
          type="primary"
          class="confirm_btn"
          @click="last_step_l"
          >下一步</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :center="true"
      title="第二步：确认送货费用"
      :visible.sync="dialogVisibleTwo"
      width="30%"
      :before-close="handleClose"
    >
      <el-divider></el-divider>
      <div class="fill_in_list_fg">
        <div class="text_iop">送货费:</div>
        <div class="text_iop text_line">{{ deliveryCost }}</div>
      </div>
      <div class="fill_in_list_fg">
        <div class="text_iop">运费:</div>
        <div class="text_iop text_line">{{ carriageCost }}</div>
      </div>
       <div class="fill_in_list_fg">
        <div class="text_iop">仓储费:</div>
        <div class="text_iop text_line">{{ storagecost }}</div>
      </div>
      <div class="fill_in_list_fg">
        <div class="text_iop">总费用:</div>
        <div class="text_iop text_line">{{ deliveryCost+ carriageCost+storagecost}}</div>
      </div>
      <div class="fill_in_list_fg">
        <div class="text_iop">余额:</div>
        <div class="text_iop text_line">{{userInfo.balance}}</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" :loading="loading" class="confirm_btn" @click="submitDelivery"
          >确认送货</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      center
      title="选择地址"
      :visible.sync="dialogVisibleAddress"
      width="40%"
      :before-close="handleClose"
    >
      <div class="flex_box">
        <el-button type="primary" @click="addAddress" plain
          >+新增收货人信息</el-button
        >
      </div>
      <div class="address_model">
        <el-radio
          width="100%"
          size="medium"
          v-model="selectAddresss"
          :label="item"
          v-for="(item, index) in addressList.content"
          :key="index"
        >
          <div class="address_item">
            <div class="user_info_title">
              <div class="user_info">
                <div class="user_name">{{ item.consignee }}</div>
                <el-button
                  v-if="item.isDefault == 1"
                  type="primary"
                  size="mini"
                  round
                  >默认地址</el-button
                >
              </div>
            </div>
            <div class="user_info">
              <div class="title_text_gh">国内收货人：</div>
              <div class="title_details">{{ item.consignee }}</div>
            </div>
            <div class="user_info">
              <div class="title_text_gh">国内电话：</div>
              <div class="title_details">{{ item.mobile }}</div>
            </div>
            <div class="user_info_title">
              <div class="user_info" style="margin: 0">
                <div class="title_text_gh">国内地址：</div>
                <div class="title_details">
                  {{ item.province }}{{ item.city }}{{ item.district
                  }}{{ item.detailArea }}
                </div>
              </div>
            </div>
          </div>
        </el-radio>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleAddress = false">取 消</el-button>
        <el-button type="primary" @click="affirmAddress">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
  title="提示"
  :visible.sync="hint"
  width="30%"
  :before-close="handleClose">
  <span>确认派送后不可自取，仓库将在2-3个工作日有人员进行派送，请保持电话畅通！</span>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = true">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      tableLoading:'',
      hint:false,
      loading:false,
      getRowKeys(row) {
        return row.id;
      },
      dialogVisibleAddress: false,
      multipleSelection: [],
      activeName: "first",
      dialogVisible: false,
      dialogVisibleTwo: false,
      screen: {
        page: 1,
        size: 10,
        state:30,
        // groupType: 50,
        // routetype: 2,
        domesticnumber: "",
        ordernumber: "",
        batchname: "",
      },
      orderData: [],
      addressList: [],
      selectAddress: {

      },
      sendAddressId: "",
      isDefault: 1,
      selectAddresss: "",
      carriageCost: 0,
      deliveryCost: 0,
      storagecost:0,
      orderIds: [],
      isfromchinaData: [],
      isfromchina: "",
      cost: 0,
      userInfo:'',
    };
  },
  created() {
    this.orderList();
    this.user();
  },
  methods: {
    last_step_l(){
   
      this.calculateDeliveryCost();
    },
        user() {
      if (typeof Cookies.get("logistics_user") == "string") {
        var logistics_user = JSON.parse(Cookies.get("logistics_user"));
      } else {
        var logistics_user = Cookies.get("logistics_user");
      }
      var data = {
        id: logistics_user.id,
      };
      crudDept.user(data).then((res) => {
        this.userInfo = res.content[0];
      });
    },
    //计算送货费用
    calculateDeliveryCost(){
      var data={
        address:{
          id:this.selectAddress.id
        },
        orderIdlist:this.orderIds.toString(),
      }
      crudDept.calculateDeliveryCost(data).then((res)=>{
        this.deliveryCost=res;
   this.dialogVisibleTwo=true;
      })
    },
    //点击确认送货
    submitDelivery() {
      if(!this.selectAddress.id){
         this.$message({
          message: '请确认送货地址',
          type: 'warning'
        });
        return false
      }
      if(this.deliveryCost*1 + this.carriageCost*1+this.storagecost*1 > this.userInfo.balance *1){
          this.$message({
          message: '您的余额不足',
          type: 'warning'
        });
        return false
      }
      var data = {
        orderIds: this.orderIds,
        sendAddressId: this.selectAddress.id,
        storageCost:this.storagecost,
        shippingCost:this.carriageCost,
        deliveryCost:this.deliveryCost,
      };
      this.loading=true;
      crudDept.confirmDelivery(data).then((res) => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
         this.loading=false
       this.dialogVisibleTwo=false;
       this.dialogVisible=false;
       this.hint=false;
        this.orderList();
           this.$refs.multipleTable.clearSelection();
        this.addressList = res;
      })      .catch((err) => {
          this.loading = false;
        });
    },
    //点击新增地址
    addAddress() {
              this.$router.push({ path: "/userInfo/addAddress?type="+this.isfromchina+'&status=0' });
    },
    //确认选择的地址
    affirmAddress() {
      //console.log(this.selectAddress);
      this.selectAddress = this.selectAddresss;
      this.dialogVisibleAddress = false;
    },
    //关闭地址弹框
    handleClose() {
      this.dialogVisibleAddress = false;
    },

    //点击选择其他地址
    selectAddressBtn() {
      this.dialogVisibleAddress = true;
      this.isDefault = "";
      this.addressData();
    },
    //收货地址
    addressData() {
      var data = {
        page: 1,
        size: 50,
        isDefault: this.isDefault,
        addresstype: this.isfromchina,
      };
      crudDept.address(data).then((res) => {
        if (this.isDefault == 1) {
          if (res.content.length > 0) {
            this.selectAddress = res.content[0];
            this.sendAddressId = res.content[0].id;
          }
        }
        //console.log(res);
        this.addressList = res;
      });
    },
    //点击要求送货‘
    clickDelivery() {
      if (this.orderIds.length == 0) {
        this.$message({
          message: "请勾选需要派送的订单",
          type: "warning",
        });
        return false;
      }
      var num=true;
      for (var i = 0; i < this.isfromchinaData.length; i++) {
        if (this.isfromchinaData[i] != this.isfromchinaData[0]) {
          num = false;
          break
        }
      }
      if (num) {
        this.isfromchina = this.isfromchinaData[0];
      } else {
        this.$message({
          message: "勾选的订单出现国内外混合订单，请重新勾选",
          type: "warning",
        });
        return false;
      }
this.hint=true;
  
      this.addressData();
    },

    //分页
    pageChange(e) {
      this.screen.page = e;
      this.orderList();
    },
    //筛查
    search() {
      this.orderList();
    },
    //重置
    reset() {
      this.screen = {
        page: 1,
        size: 10,
        domesticnumber: "",
        ordernumber: "",
        batchname: "",
        state:30,
        //         groupType: 50,
        // routetype: 2,
      };
      this.orderList();
    },
    handleSelectionChange(val) {
      //console.log(val);
      var data = val;
      var deliveryCost = 0; //派送费
      var carriageCost = 0; //运费
      var storagecost=0;
      var orderIds = [];
      var isfromchina = [];
      var index = 0;
      for (var i = 0; i < data.length; i++) {
        carriageCost += data[i].shippingcost;
        storagecost +=  data[i].storagecost;
        // deliveryCost += data[i].domesticshippingcost;
        orderIds.push(data[i].id);
        isfromchina.push(data[i].isfromchina);
      }
      this.carriageCost = carriageCost;
      this.storagecost=storagecost
      // this.deliveryCost = deliveryCost;
      this.orderIds = orderIds;
      this.isfromchinaData = isfromchina;
      this.cost = this.carriageCost + this.deliveryCost;
    },
    //订单列表
    orderList() {
      this.tableLoading=true;
      crudDept.orderList(this.screen).then((res) => {
        this.orderData = res;
        this.tableLoading=false
      }).catch((res)=>{
        this.tableLoading=false
      })
    },
    details() {
      this.$router.push({ path: "/extractGoods/details" });
    },
    productInformation() {
      this.$router.push({ path: "/parcel/productInformation" });
    },
    handleClose(done) {
        done()
    }
  },
};
</script>
<style scoped>
.paging_boxs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.paging_box_io {
  display: flex;
}
.content_box >>> .el-table .DisabledSelection .cell .el-checkbox__inner {
  /* margin-left: -30px; */
  position: relative;
}
.content_box >>> .el-table__header-wrapper .el-checkbox__input::after {
  content: "全选";
  position: absolute;
  margin-left: 10px;
  font-weight: bold;
}
.el-divider--horizontal {
  margin: 0 0 24px !important;
}
.text_line {
  text-align: left !important;
}
.text_iop {
  width: 50%;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  margin: 0 45px;
  color: #333333;
  text-align: right;
}
.fill_in_list_fg {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
.text_btn {
  margin: 0 auto !important;
  display: block;
}
.el-button.is-round {
  border-radius: 14px;
  width: 110px;
  height: 40px;
}
.fill_in_list_box {
  display: flex;
  flex-wrap: wrap;
}
.fill_in_list {
  /* width: 27%; */
  border-bottom: 1px solid #dedede;
  /* padding-bottom: 10px; */
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 16px;
  margin-right: 22px;
}
.fill_in_list_l {
  display: flex;
  align-items: baseline;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.last_step_l {
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  line-height: 44px;
  border-radius: 22px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #fff;
  text-align: center;
}
.step_box_s {
  display: flex;
  justify-content: flex-end;
  margin-top: 58px;
}
.confirm_btn {
  margin: 0 auto !important;
  background-color: #5178ff;
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  border-radius: 22px;
}
input::-webkit-input-placeholder {
  color: #999999;
}
input::-moz-input-placeholder {
  color: #999999;
}
input::-ms-input-placeholder {
  color: #999999;
}
.fill_in_list_box {
  display: flex;
  flex-wrap: wrap;
}
.fill_in_list {
  /* width: 27%; */
  border-bottom: 1px solid #dedede;
  /* padding-bottom: 10px; */
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 16px;
  margin-right: 22px;
}
.fill_in_list_l {
  display: flex;
  align-items: baseline;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #ff0e0e;
}
.numbers_info {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-bottom: 22px;
}
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: auto !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  /*height:600px;*/
  max-height: calc(100% - 30px) !important;
  max-width: calc(100% - 30px) !important;
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
.table_box {
  margin-top: 32px;
}
.el-table td,
.el-table th {
  text-align: center !important;
}
.text_li {
  color: #ffa401 !important;
}
.el-button.is-round {
  border-radius: 14px;
  width: 110px;
  height: 40px;
}
.table_item_box_s {
  display: flex;
}
.table_item_box_l_s {
  display: flex;
}
.table_item_input >>> .el-input__inner {
  background: none !important;
  outline: none !important;

  border: none;
  color: #fff !important;
  padding: 0;
}
.content_box_title {
  display: flex;
  align-items: center;
}
.circle_l {
  width: 18px;
  height: 18px;
  background: #5178ff;
  border-radius: 50%;
}
.circle_r {
  width: 18px;
  height: 18px;
  background: rgba(81, 120, 255, 0.27);
  border-radius: 50%;
  margin-left: -7px;
}
.text_xl {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  margin-left: 20px;
  color: #333333;
}
.content_box {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 38px 58px;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.table_item_box {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 25px 0 0;
  box-sizing: border-box;
}
.table_item_box_l {
  margin-right: 30px;
  text-align: left;
}
.table_item_box_l_r {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.table_item_input {
  width: 180px;
  height: 40px;
  background: #ffffff;

  border: 1px solid #dedede;
  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #ffffff;

  border: none;
  opacity: 1;

  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select >>> .el-input__inner {
  border: none !important;
  padding: 0 !important;
  width: 100% !important;
}
.input_select_table {
  padding: 0 !important;
  width: 180px;
  height: 40px;

  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #ff0e0e;
}
.address_model {
}
.address_item {
  width: 100%;
  height: auto;
  padding: 32px 44px;
  box-sizing: border-box;
  display: inline-block;

  border: 2px solid #e1e1e1;
  margin-bottom: 20px;
}
.user_info_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.user_info {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.user_name {
  margin-right: 20px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.title_text_gh {
  width: 100px;
  font-size: 15px;
  font-family: PingFang SC;
  color: #666666;
}
.title_details {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}
.address_model >>> .el-radio__inner {
  width: 26px !important;
  height: 26px !important;
  border-width: 1px !important;
}
.address_model >>> .el-radio__label {
  width: 100% !important;
}
.el-radio {
  width: 100% !important;
  display: flex;
  align-items: center;
  /* justify-content: center; */
}
.flex_box {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/deliveryOrder/want.vue